module.exports = __webpack_public_path__ + "static/media/Workshop_A_COMMERCE.87415d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Workshop_A_COMMERCE.png
// module id = 24
// module chunks = 0